import types from './types';

export const saveStatus = (status) => (dispatch) => {
  dispatch({
    type: types.SAVE_STATUS,
    payload: status,
  });
};
